import React from "react";
import "./Button.css";

export default function Button({ text, className, href, newTab, download}) {
  return (
    <div className={className}>
      <a className="main-button" href={href} download = {download}>
        {text}
      </a>
    </div>
  );
}
